import { TRESPONSE_PLANNED_ORDER_PROGRESS } from '@monorepo/types';
import * as Highcharts from 'highcharts';
import * as _ from 'lodash';
import { defaultConfig } from '../../../util';

const tooltipFunction = (data: TRESPONSE_PLANNED_ORDER_PROGRESS['lineWisePlannedAndActualValues'][number]) => {
  return `<div>Actual Qty: ${data.actualQty} <br>Planned Qty: ${data.plannedQty}   </div>`;
};

const createLineOptions = <T = unknown>(
  graphData: TRESPONSE_PLANNED_ORDER_PROGRESS['lineWisePlannedAndActualValues'],
  pointFormatterHTML: (data: T) => string,
): Highcharts.Options => {
  const chartConfig: Highcharts.Options = {
    chart: {
      type: 'column',
      height: '55%',
    },
    title: {
      text: '',
    },

    xAxis: {
      categories: graphData.map((x) => x.line),
      title: {
        text: 'Departments',
      },
    },
    yAxis: {
      title: {
        text: 'Quantity',
      },
    },
    legend: {
      reversed: true,
      align: 'left',
      verticalAlign: 'top',
    },
    plotOptions: {
      column: {
        stacking: 'normal',
      },
    },
    tooltip: {
      shared: true,
      pointFormatter: function () {
        const data = this.options.custom as T;
        if (data) {
          return pointFormatterHTML(data);
        }
        return '<div></div>';
      },
    },
    series: [
      {
        name: 'Planned',
        data: graphData.map((data, index) => {
          return {
            x: index,
            y: data.plannedQty > data.actualQty ? data.plannedQty - data.actualQty : 0,
            custom: data,
          };
        }),
        type: 'column',
        color: '#A3A3A7',
      },
      {
        name: 'Actual',
        data: graphData.map((data, index) => {
          return {
            x: index,
            y: data.actualQty,
          };
        }),
        type: 'column',
        color: '#0F31A9',
      },
    ],
  };
  return chartConfig;
};

export const PLANNED_ORDER_PROGRESS_CHART_MODEL = {
  createModel: (departmentData: TRESPONSE_PLANNED_ORDER_PROGRESS['lineWisePlannedAndActualValues']) => {
    const defaultConfigCopy = _.cloneDeep(defaultConfig);
    return _.merge(defaultConfigCopy, createLineOptions(departmentData, tooltipFunction));
  },
};
